import { render, staticRenderFns } from "./BuyPurchaseHistory.vue?vue&type=template&id=1fe4264c&scoped=true&"
import script from "./BuyPurchaseHistory.vue?vue&type=script&lang=js&"
export * from "./BuyPurchaseHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuyPurchaseHistory.vue?vue&type=style&index=0&id=1fe4264c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe4264c",
  null
  
)

export default component.exports